import { SxProps, Theme } from '@mui/material';

import { themeColors } from '@/config/theme/themeColors.ts';

export const cvSearchSyncStatusStyles = {
  counter: {
    border: `1px solid ${themeColors.stroke}`,
    borderRadius: 1,
    display: 'flex',
    flexDirection: 'column',
    p: 1,
  },
  countersGrid: {
    display: 'grid',
    gap: 1,
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
  dot: (color: string): SxProps<Theme> => ({
    backgroundColor: color,
    border: `2px solid ${themeColors.white}`,
    borderRadius: '50%',
    bottom: 4,
    height: 12,
    position: 'absolute',
    right: 4,
    width: 12,
  }),
  drawer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    maxWidth: '100vw',
    p: 3,
    width: 560,
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    gap: 1,
  },
  itemDetail: {
    color: themeColors.gray_20,
    overflowWrap: 'anywhere',
  },
} satisfies Record<string, SxProps<Theme> | ((color: string) => SxProps<Theme>)>;
